import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import queryString from "query-string";
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import TermsAndConditionsModal from "../../TermsAndConditionsModal/TermsAndConditionsModal";

import axios from "../../../../axios-instance";
import Upload from "../../../Upload/Upload";
import Container from "../../../../components/UI/Container/Container";
import Membership2025Adult from "../../../../images/membership2025-adult-new.jpg";
import Membership2025Child from "../../../../images/membership2025-child-new.jpg";
import MembershipOld from "../../../../images/membership2025-child.png";
import { IconButton } from "../../../../components/UI/IconButton/IconButton";
import Page404 from "../../../../components/Page404/Page404";
import NewLoader from "../../../../components/NewLoader/NewLoader";
import PleaseWait from "../../../../images/please-wait-season-pass-modal.svg";

import "../SeasonPassPersonalInfo.sass";
import Icon from "../../../../components/UI/Icon/Icon";
import { showErrorModal } from "../../../../modals";
import { ticketTemplateIds } from "../../constants";
import { TicketsPicker } from "../../../OpenSell/TicketsPicker";
import { getCurrencieLabel } from "../../../../constants/currencies";
import { days, month, years } from "../../constants";
import { getCurrentLanguageTexts, setLangCode } from "../../../../constants/seasonPassPersonalInfoLangs";

import { editMembeshipCardInfo, getMemberCards } from "../../../../store/actions/memberActions";
import ls from 'localstorage-slim';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { BuyMembershipModal } from "../Modals/BuyMembershipModal";
import CheckBox from "../../../../components/UI/Checkbox/CheckBox";
import { executePayment } from "../../../../helpers/paymentHelper/paymentHelper.ts";
import { paymentTypes } from "../../../../constants/paymentType.ts";
import { handleOrderStatus } from "../../../../components/Sells/Modals/statusModals.js";
import { getOc } from "../../../../helpers/optionalChain.ts";

const MySwal = withReactContent(Swal);

export const MemberTickets = ({
  dispatch,
  membershipList,
  getMemberCards,
  editMembeshipCardInfo,
  handleChangeMemberFound,
  ...params
}) => {
  const allowMembershipSell = true; // always allow

  const [isLoadingState, setIsLoadingState] = useState(true);
  const [isMemberFound, setIsMemberFound] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isEventDataLoading, setIsEventDataLoading] = useState(false);

  const formRef = useRef(null);
  const blockRef = useRef(null);
  const [blockWidth, setBlockWidth] = useState('300px');

  const [paymentAmount, setPaymentAmount] = useState(0);
  const [currencyCode, setCurrencyCode] = useState("RSD");
  const [tickets, setTickets] = useState([]);
  const [eventData, setEventData] = useState(null);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState(null);
  const [streetAndHouseNumber, setStreetAndHouseNumber] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [isPersonalDataChanged, setPersonalDataChanged] = useState(false);

  const [points, setPoints] = useState("");
  const [seasonPassList, setSeasonPassList] = useState([]);
  const [seasonPassListForDelete, setSeasonPassListForDelete] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [canSave, setCanSave] = useState(true);
  const [isPendingToApprove, setIsPendingToApprove] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [birthday, setBirthday] = useState(null);
  const [memberStatus, setMemberStatus] = useState(null);

  const [pickerData, setPickerData] = useState({
    year: null,
    month: null,
    days: null,
  });
  const [defaultLang, setDefaultLang] = useState("en");

  const txt = getCurrentLanguageTexts();

  const handleLang = (lang) => {
    const acceptedLangs = ['en', 'rs'];
    if (!lang || !acceptedLangs.some((key) => key == lang)) {
      setLangCode('rs');
      setDefaultLang("rs");
      return;
    }

    setLangCode(lang);
    setDefaultLang(lang);
  };

  const pageAction = queryString.parse(params.location.search).action;

  const token = ls.get('member-access-token', '');

  const authResult = queryString.parse(params.location.search)["?authResult"];

  const checkActionButtonDisabled = () => {
    let res = !(
      birthday &&
      firstname &&
      lastname &&
      phone &&
      phone.length > 4 &&
      gender &&
      streetAndHouseNumber &&
      city &&
      postalCode &&
      true
    );

    return res;
  };

  const changeInputFirstnameHandler = (e) => {
    setFirstname(e.target.value);
    setPersonalDataChanged(!!e.target.value.trim());
  };

  const changeInputLastnameHandler = (e) => {
    setLastname(e.target.value);
    setPersonalDataChanged(!!e.target.value.trim())
  };

  const changeInputEmailHandler = (e) => {
    setEmail(e.target.value.trim());
  };

  const changeInputPhoneHandler = (phone) => {
    setPhone(phone);
    setPersonalDataChanged(!!phone)
  };

  const changeInputGenderHandler = (gender) => {
    setGender(gender.value);
    setPersonalDataChanged(true);
  };

  const changeInputStreetAndHouseNumberHandler = (e) => {
    setStreetAndHouseNumber(e.target.value);
    setPersonalDataChanged(!!e.target.value.trim())
  };

  const changeInputCityHandler = (e) => {
    setCity(e.target.value);
    setPersonalDataChanged(!!e.target.value.trim())
  };

  const changeInputPostalCodeHandler = (e) => {
    setPostalCode(e.target.value);
    setPersonalDataChanged(!!e.target.value.trim())
  };

  const showTermsAndConditionsModal = (ev) => {
    ev.preventDefault();
    MySwal.fire({
      html: <TermsAndConditionsModal />,
      width: "64em",
      customClass: "seasonpass__modal partizan-modal",
    });
  };

  const handleChangeDate = (type, date) => {
    let newPickerData = { ...pickerData, [type]: date };

    setPickerData(newPickerData);

    const isNoEmpty = Object.keys(newPickerData).every(
      (key) => typeof newPickerData[key] === "number"
    );

    if (isNoEmpty) {
      const birthday = moment()
        .year(newPickerData.year)
        .month(newPickerData.month)
        .set("D", newPickerData.days)
        .toDate();

      setBirthday(birthday);
      setPersonalDataChanged(!!birthday)
    }
  };

  const showPleaseWaitModal = () => {
    MySwal.fire({
      imageUrl: PleaseWait,
      title: waitModalTxt.title,
      text: waitModalTxt.description,
      allowEscapeKey: false,
      customClass: "partizan-modal seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  const setPrice = (ticks) => {
    setPaymentAmount(
      ticks.reduce((accumulator, ticket) => {
        return accumulator + ticket.price * ticket.count;
      }, 0)
    );
  };

  const onObjectSelected = (obj) => {
    let ticks = [...tickets, obj];

    let findedTicket = tickets.find(
      ({ ticketTemplateId }) => ticketTemplateId === obj.ticketTemplateId
    );

    if (findedTicket) {
      ticks = tickets.map((ticket) =>
        ticket.ticketTemplateId === obj.ticketTemplateId ? obj : ticket
      );
    }

    setPrice(ticks);
    setTickets(ticks);
  };

  const onObjectDeselected = (obj) => {
    const ticks = tickets.filter(
      (item) => item.ticketTemplateId !== obj.ticketTemplateId
    );
    setPrice(ticks);
    setTickets(ticks);
  };

  const getEventData = async () => {
    setIsEventDataLoading(true);
    const memberEventSlug = process.env.REACT_APP_MEMBER_EVENT_SLUG;
    const { data } = await axios.get(`/EventPublicInfo/BySlug/${memberEventSlug}`);

    const seasonData = await axios.get(`/EventPublicInfo/BySlug/${process.env.REACT_APP_NEW_SEASON_EVENT_SLUG}`);

    setCurrencyCode(
      getCurrencieLabel(data.currencyId)
    );
    if (pageAction === 'selling') {
      seasonData.data.feeRate = 0;
      data.feeRate = 0;
    }
    setEventData(data);
    setIsEventDataLoading(false);
  };

  const createOrder = async (buyer, companyInfo) => {

    await executePayment({
      eventData: eventData,
      paymentMethod: 0,
      paymentType: paymentTypes.online,
      redirectUrl: window.location.href.includes('?') ? window.location.href + "&resultOrderId={id}"
        : window.location.href + "?resultOrderId={Id}",
      tickets: tickets,
      transaction: {
        fullName: firstname + ' ' + lastname,
        physicalAddress: streetAndHouseNumber,
        city,
        postalCode,
        phoneNumber: phone,
        buyerEmail: email,
        birthday: birthday,
        gender: gender,
        ...companyInfo
      }

    })
  }

  const getOrderData = async () => {
    const urlParams = new URL(window.location.href).searchParams;
    const orderId = urlParams.get('resultOrderId');

    if (!!orderId) {
      const { data } = await axios.get(
        `Order/${orderId}?byTransactionId=true`);

      handleOrderStatus({
        status: data.status,
        orderId,
        buyerEmail: data.info.buyerEmail,
        additionalPaymentStatus: data.externalStatus,
        paymentData: data.paymentDate,
        buyMoreUrl: window.location.pathname,
        authCode: getOc(data, '?.info?.kopaInfo?.authCode', ' '),
        reloadData: getOrderData,
      })
    }
  }

  const showBuyMembershipModal = () => {
    MySwal.fire({
      title: buyMembershipTxt.buyTitle,
      html: <BuyMembershipModal text={buyMembershipTxt.buyDescription} handleBuy={handleBuy} />,
      showConfirmButton: false,
      customClass: "partizan-modal delete-user-modal",
    });
  }

  const handleBuyMembership = () => {
    if (checkActionButtonDisabled()) {
      toast.error(buyMembershipTxt.emptyDataErrorMessage)

      return;
    }

    if (isPersonalDataChanged) {
      MySwal.fire({
        title: buyMembershipTxt.saveMessage,
        customClass: "partizan-modal delete-user-modal",
        confirmButtonText: buyMembershipTxt.saveBtn,
        cancelButtonText: buyMembershipTxt.cancelBtn,
        showCancelButton: true,
        reverseButtons: true,
      }).then(({ value }) => {
        if (value) {
          handleConfirmSaveChanges();
        } else {
          throw new Error("")
        }
      }).then(() => {
        showBuyMembershipModal();
      }).catch(() => {
        MySwal.close();
      });
    } else {
      showBuyMembershipModal()
    }
  };

  const handleBuy = async (buyer, companyInfo) => {
    try {
      showPleaseWaitModal();

      await createOrder(buyer, companyInfo);
      formRef.current.submit();
    } catch (e) {
      console.log(e);
      showErrorModal({
        text: errorModalTxt.description,
        customClass:
          "seasonpass__modal_info partizan-modal partizan-info-modal",
      });
    }
  };

  const deleteFile = (file, type) => {
    MySwal.fire({
      title: deleteFileTxt.title,
      text: deleteFileTxt.description,
      confirmButtonText: deleteFileTxt.confirmBtn,
      cancelButtonText: deleteFileTxt.cancelBtn,
      showCancelButton: true,
      reverseButtons: true,
      customClass: "partizan-modal delete-user-modal",
    }).then(({ value }) => {
      if (value) {
        if (type === "local") {
          setFilesList((currFiles) => currFiles.filter((f) => f !== file));
        } else {
          setSeasonPassList((currSeasons) =>
            currSeasons.filter((season) => season.id !== file.id)
          );

          setSeasonPassListForDelete((currSeasons) => [...currSeasons, file]);
        }
      }
    });
  };

  const onAddFileHandler = (files, clearAllSelected) => {
    if (files.length > 0) {
      const fileReader = new FileReader();

      fileReader.onloadend = () => {
        setFilesList((currFiles) => [
          ...currFiles,
          { file: files[0], url: fileReader.result },
        ]);

        clearAllSelected();
      };

      fileReader.readAsDataURL(files[0]);
    }
  };

  const loadSeasonPassMember = async () => {
    await axios
      .get(`/SeasonPassMember?accessToken=${token}`)
      .then((response) => {
        if (response.status === 200 && response.data) {

          getOrderData();

          setFirstname(response.data.firstName);
          setLastname(response.data.lastName);
          setEmail(response.data.email);
          setPhone(response.data.phoneNumber);
          setGender(response.data.gender);
          setStreetAndHouseNumber(response.data.physicalAddress);
          setCity(response.data.city);
          setPostalCode(response.data.postalCode);
          setPoints(response.data.points);
          setIsPendingToApprove(response.data.status === 2);
          setMemberStatus(response.data.status);

          if (response.data.dateOfBirth && response.data.dateOfBirth !== "0001-01-01T00:00:00") {
            setPickerData({
              year: moment(response.data.dateOfBirth).year(),
              month: moment(response.data.dateOfBirth).month(),
              days: +moment(response.data.dateOfBirth).format("D"),
            });
            setBirthday(response.data.dateOfBirth);
          }

          //handleLang(response.data.lang);
          if (response.data.status === 3) {
            getEventData();
            setIsApproved(true);
          }
          localStorage.setItem('user_' + response.data.email.toLowerCase().trim(), token);
          setIsMemberFound(true);
          setIsLoadingState(false);

          if (pageAction == 'edit') {
            setIsPendingToApprove(false);
            setIsApproved(false);
          }
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        setIsLoadingState(false);
        setIsMemberFound(false);
        handleChangeMemberFound(false);
      });

    await axios
      .get(`/Membership/passes?accessToken=${token}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          const list = response.data.filter(
            (season) => season.requestedToUpdate
          );

          setSeasonPassList(list);
          setIsMemberFound(true);
          setIsLoadingState(false);
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        setIsLoadingState(false);
        setIsMemberFound(false);
        handleChangeMemberFound(false);
      });
  };

  useEffect(() => {
    if (token) {
      getMemberCards(token, process.env.REACT_APP_MEMBER_EVENT_ID);
    }

    if (pageAction === 'edit') {
      setPersonalDataChanged(true);
    }
  }, [token]);

  const { confirmSaveChanges, pointsTable, buyMembershipTxt, waitModalTxt, errorModalTxt, deleteFileTxt, dataFormTxt, SeasonPassListTxt } = getCurrentLanguageTexts();

  const handleConfirmSaveChanges = () => {
    const data = {
      firstName: firstname,
      lastName: lastname,
      phoneNumber: phone,
      physicalAddress: streetAndHouseNumber,
      city: city,
      postalCode: postalCode,
      dateOfBirth: birthday,
      gender: gender || 0,
    };

    if (pageAction !== 'edit') {
      axios
        .put(`/SeasonPassMember?accessToken=${token}&isFinal=${false}`, data)
        .then((response) => {
          if (response.status === 200 && response.data) {

            toast.success(txt.PersonalInfoUpdating.success);
            return;
          }

          throw new Error(response.data.errorMessage);
        })
        .catch((err) => {
          toast.error(txt.PersonalInfoUpdating.error);
        });

      setPersonalDataChanged(false);

      return;
    }

    setIsPendingToApprove(true);
    axios
      .put(`/SeasonPassMember?accessToken=${token}&isFinal=${false}`, data)
      .then((response) => {
        if (response.status === 200 && response.data) {

          if (response.data.result == 2) // Pending to approve
          {
            setIsPendingToApprove(true);
            setIsApproved(false);
          }
          else {// Pending approved
            setIsPendingToApprove(false);
            // setIsApproved(true);
            toast.success(txt.PersonalInfoUpdating.success)
          }
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error(txt.PersonalInfoUpdating.error);
        setIsPendingToApprove(false);
      });

    filesList.forEach((value, index, array) => {
      const data = new FormData();
      data.append("file", value.file);

      axios
        .post(
          `/SeasonPassMember/attach-season-pass-photo?accessToken=${token}`,
          data
        )
        .then((response) => {
          if (response.status === 200 && response.data) {
            return;
          }

          throw new Error(response.data.errorMessage);
        })
        .catch((err) => {
          toast.error("Something went wrong");
        });
    });

    seasonPassListForDelete.forEach((season, index, array) => {
      axios
        .delete(
          `/SeasonPassMember/detach-season-pass-photo?seasonPassId=${season.id}&accessToken=${token}`
        )
        .then((response) => {
          if (response.status === 200 && response.data) {
            return;
          }

          throw new Error(response.data.errorMessage);
        })
        .catch((err) => {
          toast.error("Something went wrong");
        });
    });
  }

  const showConfirmSaveChangesModal = () => {
    MySwal.fire({
      title: confirmSaveChanges.title,
      confirmButtonText: confirmSaveChanges.btnConfirm,
      cancelButtonText: confirmSaveChanges.btnCancel,
      showCancelButton: true,
      reverseButtons: true,
      customClass: "partizan-modal delete-user-modal",
    }).then(({ value }) => {
      if (value) {
        const data = {
          firstName: firstname,
          lastName: lastname,
          phoneNumber: phone,
          physicalAddress: streetAndHouseNumber,
          city: city,
          postalCode: postalCode,
          dateOfBirth: birthday,
          gender: gender || 0,
        };

        if (pageAction !== 'edit') {
          setIsLoadingState(true);
          axios
            .put(`/SeasonPassMember?accessToken=${token}&isFinal=${false}`, data)
            .then((response) => {
              if (response.status === 200 && response.data) {

                toast.success(txt.PersonalInfoUpdating.success);
                return;
              }

              throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
              toast.error(txt.PersonalInfoUpdating.error);
              setIsLoadingState(false);
            })
            .then(() => {
              loadSeasonPassMember();
            });

          setPersonalDataChanged(false);

          return;
        }

        setIsPendingToApprove(true);
        axios
          .put(`/SeasonPassMember?accessToken=${token}&isFinal=${false}`, data)
          .then((response) => {
            if (response.status === 200 && response.data) {

              if (response.data.result == 2) // Pending to approve
              {
                setIsPendingToApprove(true);
                setIsApproved(false);
              }
              else {// Pending approved
                setIsPendingToApprove(false);
                // setIsApproved(true);
                toast.success(txt.PersonalInfoUpdating.success)
              }
              return;
            }

            throw new Error(response.data.errorMessage);
          })
          .catch((err) => {
            toast.error(txt.PersonalInfoUpdating.error);
            setIsPendingToApprove(false);
          });

        filesList.forEach((value, index, array) => {
          const data = new FormData();
          data.append("file", value.file);

          axios
            .post(
              `/SeasonPassMember/attach-season-pass-photo?accessToken=${token}`,
              data
            )
            .then((response) => {
              if (response.status === 200 && response.data) {
                return;
              }

              throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
              toast.error("Something went wrong");
            });
        });

        seasonPassListForDelete.forEach((season, index, array) => {
          axios
            .delete(
              `/SeasonPassMember/detach-season-pass-photo?seasonPassId=${season.id}&accessToken=${token}`
            )
            .then((response) => {
              if (response.status === 200 && response.data) {
                return;
              }

              throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
              toast.error("Something went wrong");
            });
        });
        handleConfirmSaveChanges();
      }
    });
  };

  const getTicketTemplates = () => {
    let ticks = [];

    ticks = eventData.ticketTemplates.filter((t) => t != null && t.isAvailableToSale).map((ticket) => {
      if (ticket.name.toLowerCase().includes("extend")) {
        const numberOfExtendTickens = tickets.reduce((num, item) => {
          if (
            item.name.toLowerCase().includes("extend") &&
            ticket.ticketTemplateId !== item.ticketTemplateId
          ) {
            return num + item.count;
          }
          return num;
        }, 0);

        if (numberOfExtendTickens) {
          return {
            ...ticket,
            allowedToSell:
              seasonPassList.length - numberOfExtendTickens > 0
                ? seasonPassList.length - numberOfExtendTickens
                : 0,
          };
        }

        return { ...ticket, allowedToSell: seasonPassList.length };
      }
      return ticket;
    });

    let count = 0;
    for (let j = 0; j < membershipList.length; j++) {
      if (membershipList[j].ticketName.toLowerCase().includes("extend")) {
        ++count;
      }
    }
    for (let i = 0; i < ticks.length; i++) {
      if (
        count >= seasonPassList.length &&
        ticks[i].name.toLowerCase().includes("extend")
        && process.env.REACT_APP_ENV_NAME !== "development"
      ) {
        delete ticks[i];
      }
    }
    ticks.forEach((t, i) => {
      ticks[i].imgUrl =
        ticketTemplateIds.child.includes(ticks[i].ticketTemplateId) && Membership2025Child
        || ticketTemplateIds.adult.includes(ticks[i].ticketTemplateId) && Membership2025Adult
        || MembershipOld;
    });

    return ticks;
  };

  useEffect(() => {
    const lang = queryString.parse(params.location.search).lang;

    handleLang(queryString.parse(params.location.search).lang);
    loadSeasonPassMember();
  }, [authResult]);

  useEffect(() => {
    if (blockRef.current) {
      setBlockWidth(
        getComputedStyle(blockRef.current).width
      )
    }
  }, [blockRef.current]);

  useEffect(() => {
    window.addEventListener('beforeunload', (event) => {
      MySwal.close();
      setIsLoadingState(true);
    });

    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        window.location.reload();
      }
    });
  }, [])

  if (isLoadingState || isEventDataLoading) {
    return <NewLoader />;
  }

  if (!isMemberFound) {
    return <Page404 />;
  }

  const genders = [
    { label: dataFormTxt.male, value: 1 },
    { label: dataFormTxt.female, value: 2 },
  ];

  return (
    <Container className="seasonpass seasonpass-pers-info">

      <div className="seasonpass-pers-info__logo seasonpass-pers-info__header-logo-wrapper">
        {/* <img src={PartizanOpenSellingLogo} alt="Logo" />
        <h2>SixTix</h2> */}
      </div>
      <div className="seasonpass-pers-info__main-block">
        {isPendingToApprove ? (
          <div className="seasonpass-pers-info__notification">
            <Icon name="clock-white" />
            <h4>{waitModalTxt.waitingForReview}</h4>
          </div>
        ) : null}
        <h2 className="first-title">{dataFormTxt.personalInfoTitle}</h2>
        <div className="seasonpass-pers-info__row">
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.firstName}</label>
              <input
                type="text"
                name="firstname"
                placeholder=""
                value={firstname}
                onChange={changeInputFirstnameHandler}
              />
            </div>
          </div>

          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.lastName}</label>
              <input
                type="text"
                name="lastname"
                placeholder=""
                value={lastname}
                onChange={changeInputLastnameHandler}
              />
            </div>
          </div>
        </div>
        <div className="seasonpass-pers-info__row">
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block" ref={blockRef}>
              <label>{dataFormTxt.email}</label>
              <input
                type="text"
                name="email"
                className="email-disable"
                placeholder=""
                value={email}
                onChange={changeInputEmailHandler}
                disabled
              />
            </div>
          </div>
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.phone}</label>
              <PhoneInput
                inputClass="custom-phone-number-input"
                buttonClass="custom-phone-number-button"
                dropdownClass="custom-phone-number-dropdown"
                searchClass="custom-phone-number-search"
                dropdownStyle={{ width: blockWidth }}
                searchPlaceholder={dataFormTxt.countrySearchPlaceholder}
                searchNotFound={dataFormTxt.countryNotFound}
                country={!phone ? 'rs' : ''}
                enableSearch={true}
                disableSearchIcon={true}
                value={phone}
                onChange={changeInputPhoneHandler}
              />
            </div>
          </div>
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.gender}</label>
              <Select
                options={genders}
                name="gender"
                placeholder={txt.sellPageFieldsTxt["Select your gender"]}
                value={genders.find(({ value }) => gender === value)}
                onChange={changeInputGenderHandler}
                classNamePrefix="partizan-open-selling__select"
                className="partizan-open-selling__select"
              />
            </div>
          </div>
        </div>
        <div className="seasonpass-pers-info__row">
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.streetAndHouse}</label>
              <input
                type="text"
                name="street-and-house-number"
                placeholder=""
                value={streetAndHouseNumber}
                onChange={changeInputStreetAndHouseNumberHandler}
              />
            </div>
          </div>
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.city}</label>
              <input
                type="text"
                name="city"
                placeholder=""
                value={city}
                onChange={changeInputCityHandler}
              />
            </div>
          </div>
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.postalCode}</label>
              <input
                type="text"
                name="postal-code"
                placeholder=""
                value={postalCode}
                onChange={changeInputPostalCodeHandler}
              />
            </div>
          </div>
        </div>
        <div className="seasonpass-pers-info__row">
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.year}</label>
              <Select
                name="year"
                options={years}
                placeholder=""
                value={years.find(({ value }) => pickerData.year === value)}
                onChange={(value) => handleChangeDate("year", value.value)}
                classNamePrefix="partizan-open-selling__select"
                className="partizan-open-selling__select"
              />
            </div>
          </div>
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.month}</label>
              <Select
                name="month"
                options={month}
                placeholder=""
                value={month.find(({ value }) => pickerData.month === value)}
                onChange={(value) => handleChangeDate("month", value.value)}
                classNamePrefix="partizan-open-selling__select"
                className="partizan-open-selling__select"
              />
            </div>
          </div>
          <div className="seasonpass-pers-info__column">
            <div className="seasonpass-pers-info__block">
              <label>{dataFormTxt.day}</label>
              <Select
                name="day"
                options={days}
                placeholder=""
                value={days.find(({ value }) => pickerData.days === value)}
                onChange={(value) => handleChangeDate("days", value.value)}
                classNamePrefix="partizan-open-selling__select"
                className="partizan-open-selling__select"
              />
            </div>
          </div>
        </div>
        <button
          className="btn-primary save-changes"
          disabled={!isPersonalDataChanged || checkActionButtonDisabled()}
          onClick={showConfirmSaveChangesModal}
        >
          {dataFormTxt.saveChanges}
        </button>

        {!isApproved && memberStatus !== 1 && allowMembershipSell && (
          <>
            <h2 className="first-title">{SeasonPassListTxt.spListTitle}</h2>
            <div className="seasonpass-pers-info__list">
              {seasonPassList.map((season) => (
                <div className="upload-img">
                  <img src={season.confirmationPhotoUrl} />
                  {!isPendingToApprove && (
                    <IconButton
                      disabled={!canSave}
                      iconName="trash"
                      className="btn-red IconButton"
                      onClick={() => deleteFile(season, "remote")}
                    />
                  )}
                </div>
              ))}
              {filesList.map((file) => (
                <div className="upload-img">
                  <img src={file.url} />
                  {!isPendingToApprove && (
                    <IconButton
                      disabled={!canSave}
                      iconName="trash"
                      className="btn-red IconButton"
                      onClick={() => deleteFile(file, "local")}
                    />
                  )}
                </div>
              ))}
              {!isPendingToApprove && (
                <>
                  <Upload
                    accept="image/png, image/jpeg, image/*"
                    onButtonEnable={onAddFileHandler}
                  />
                </>
              )}
            </div>
          </>
        )}

        {isApproved && allowMembershipSell && eventData && (
          <>
            <h2 className="first-title">{buyMembershipTxt.buyMembershipsListTitle}</h2>
            <div className="seasonpass-pers-info__tick-list">
              <TicketsPicker
                canSelect={
                  tickets.reduce((num, item) => num + item.count, 0) <
                  eventData.maxSeatsToSelectPerTransaction
                }
                onObjectSelected={onObjectSelected}
                onObjectDeselected={onObjectDeselected}
                ticketTemplates={getTicketTemplates()}
                currency={currencyCode}
              />
            </div>
            <div className="seasonpass-pers-info__tick-total">
              <span className="">{buyMembershipTxt.total} </span>
              <span className="">
                {paymentAmount} {currencyCode}
              </span>
            </div>
            <CheckBox
              checked={isTermsChecked}
              id="terms-and-conditions-checkbox"
              name="terms-and-conditions-checkbox"
              onChange={() => setIsTermsChecked(!isTermsChecked)}
            >
              <span className="partizan-open-selling__text-medium-small">
                {buyMembershipTxt.iAgreeWith}
                <span
                  className="partizan-open-selling__terms-of-service-text" style={{ color: '#d7b36c' }}
                  onClick={showTermsAndConditionsModal}
                >
                  {buyMembershipTxt.termsOfService}
                </span>
              </span>
            </CheckBox>
            <button
              className="btn-primary save-changes"
              disabled={!paymentAmount || !isTermsChecked}
              onClick={handleBuyMembership}
            >
              {buyMembershipTxt.buy}
            </button>
          </>
        )}

        {memberStatus !== 1 && (
          <span className="seasonpass-pers-info__points-total">
            {pointsTable.totalPoints} : {points}
          </span>
        )}
      </div>
    </Container>
  );
};

const mapStateToProps = ({ member }) => ({
  membershipList: member.membershipList,
});
const mapDispatchToProps = (dispatch) => ({
  getMemberCards: (accessToken, eventId) =>
    dispatch(getMemberCards(accessToken, eventId)),
  editMembeshipCardInfo: (accessToken, ticket) =>
    dispatch(editMembeshipCardInfo(accessToken, ticket)),
  dispatch: (foo) => dispatch(foo),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberTickets);